/**
 * Batch capacity helpers — enforce maxCapacity when set.
 */

export function getBatchStudentCount(batch, stats) {
  if (stats && typeof stats.total === 'number') return stats.total;
  if (typeof batch?.studentCount === 'number') return batch.studentCount;
  return 0;
}

export function getBatchCapacity(batch) {
  const cap = batch?.maxCapacity;
  if (cap == null || cap === '') return null;
  const n = Number(cap);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function isBatchAtCapacity(batch, stats) {
  const capacity = getBatchCapacity(batch);
  if (capacity == null) return false;
  return getBatchStudentCount(batch, stats) >= capacity;
}

export function getBatchSeatsLeft(batch, stats) {
  const capacity = getBatchCapacity(batch);
  if (capacity == null) return null;
  return Math.max(0, capacity - getBatchStudentCount(batch, stats));
}

export function getBatchCapacityMessage(batch, stats) {
  const capacity = getBatchCapacity(batch);
  if (capacity == null) return null;
  const count = getBatchStudentCount(batch, stats);
  const seatsLeft = Math.max(0, capacity - count);
  if (seatsLeft === 0) {
    return `"${batch?.name || 'This batch'}" is full (${count}/${capacity} students). Increase capacity or close registration before adding more students.`;
  }
  return null;
}
